import isEqual from "lodash/fp/isEqual";
import some from "lodash/fp/some";
import keys from "lodash/fp/keys";
import flow from "lodash/fp/flow";
import pick from "lodash/fp/pick";

export default function getIsOutOfStock({
  userChoiceValues,
  outOfStockVariations,
}) {
  return some((outOfStockVariation) => {
    return flow(
      keys,
      (keys) => pick(keys)(userChoiceValues),
      isEqual(outOfStockVariation)
    )(outOfStockVariation);
  })(outOfStockVariations);
}
